module.exports = __webpack_public_path__ + "static/1-98679cbcc6aeec0ed0acc8ce93046017.jpg";